import Icon from "@/icons";
import Tippy from "@tippyjs/react";
import React from "react";
import Textarea from "./Input/Textarea";
import TaggingMemberSystem from "./Input/Tagging/User/TaggingMember";
import UserMentionSelecting from "./Input/Tagging/User/UserMention";
import Attachments from "./Input/Attachments";
import Replying from "./Input/Replying";
import EmojiSelection from "./Input/Tagging/Emoji/EmojiSelecting";
import SelectEmoji from "./Input/Tagging/Emoji/Selecting";
import EmojiDropdown from "@/components/Dropdown/Emojis";
export default function msgInput({
    replyTo,
    setReplyTo,
    sendMessage,
    textareaRef,
    setSend,
    canBeSend,
    channel,
    setAttachments,
    attachments = [],
    members,
    me,
    emojis
}: {
    replyTo: any,
    setReplyTo: any,
    sendMessage: any,
    textareaRef: any,
    setSend: any,
    canBeSend: any,
    channel: any,
    setAttachments: any,
    attachments: any,
    members: any,
    me: any,
    emojis: any
}) {
    const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (attachments.length >= 5) return;
        const file = event.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = async () => {
                const formData = new FormData();
                formData.append("image", file);
                formData.append("type", "attachment");
                const res = await fetch("__SITE_BASE__/api/v1/upload", {
                    method: "POST",
                    body: formData
                });
                const data = await res.json();
                if (data.message) return;
                setSend(true);
                setAttachments([{
                    url: data.url,
                    name: file.name,
                    fileSizeBytes: file.size
                }, ...attachments]);
            };
            reader.readAsDataURL(file);
            event.target.value = '';
        }
    };

    const fileInputRef = React.useRef<HTMLInputElement>(null);

    const handleFileButtonClick = () => {
        if (attachments.length >= 5) return;
        if (fileInputRef.current) fileInputRef.current.click();
    };

    const [searchTerm, setSearchTerm] = React.useState("");

    let { filteredMembers, tagMember, isTagging, setIsTagging, focusedMember, setFocusedMember }: any = TaggingMemberSystem({
        textareaRef,
        members,
        searchTerm,
        setSearchTerm,
    });

    let {
        filteredEmojis,
        focusedEmoji,
        setFocusedEmoji,
        tagEmoji,
        isSelectingEmoji,
        setIsSelectingEmoji,
        
    }: any = SelectEmoji({
        textareaRef,
        searchTerm,
        setSearchTerm,
    });
    const selectingEmote = async () => {
        if (textareaRef.current) {
            const textarea = textareaRef.current;
            const selectionStart = textarea.selectionStart;
            const lastColon = textarea.value.lastIndexOf(":", selectionStart - 1);
            const lastSpace = textarea.value.lastIndexOf(" ", selectionStart - 1);
            const hasEmoji = textarea.value.slice(lastColon + 1, selectionStart).includes(">");
            if (lastColon > lastSpace && !hasEmoji) {
                setIsSelectingEmoji(true);
                setSearchTerm(textarea.value.slice(lastColon + 1, selectionStart));
            } else {
                setIsSelectingEmoji(false);
                setFocusedEmoji(0);
            }
        }
    }
    const tagging = async () => {
        if (textareaRef.current) {
            const textarea = textareaRef.current;
            const selectionStart = textarea.selectionStart;
            const lastAt = textarea.value.lastIndexOf("@", selectionStart - 1);
            const lastSpace = textarea.value.lastIndexOf(" ", selectionStart - 1);
            const hasTag = textarea.value.slice(lastAt + 1, selectionStart).includes(">");
            if (lastAt > lastSpace && !hasTag) {
                setIsTagging(true);
                setSearchTerm(textarea.value.slice(lastAt + 1, selectionStart));
            } else {
                setIsTagging(false);
                setFocusedMember(0);
            }
        }
    };


    return (
        <>
            <div className="relative flex items-center rounded-lg w-full">
                {isTagging && (
                    <UserMentionSelecting filteredMembers={filteredMembers} focusedMember={focusedMember} tagMember={tagMember} />
                )}
                {isSelectingEmoji && (
                    <EmojiSelection filteredEmojis={filteredEmojis} focusedEmoji={focusedEmoji} tagEmoji={tagEmoji} />
                )}
                <div className="flex flex-col items-center rounded-lg w-full">
                    {replyTo && (
                        <Replying replyTo={replyTo} setReplyTo={setReplyTo} />
                    )}
                    {Array.isArray(attachments) && attachments.length > 0 && (
                        <Attachments attachments={attachments} setAttachments={setAttachments} textareaRef={textareaRef} setSend={setSend} replyTo={replyTo} />
                    )}
                    <div className={`flex items-start space-x-2 rounded-lg bg-brand-top ${replyTo || attachments.length ? 'rounded-t-none' : ''} px-2 w-full`}>
                        <div className="flex items-start gap-2 w-full">
                            <div className="flex items-start space-x-2 px-2 rounded-full">
                                <div className="flex items-center space-x-2 px-1 py-1 mt-1 text-gray-200 rounded-full">
                                    {attachments.length >= 5 && (
                                        <Tippy content="You can only upload 5 attachments at a time" placement="top" arrow={false}>
                                            <div className="flex items-center justify-center px-2 bg-brand-gray h-8 w-8 rounded-full bg-brand-red transition-all duration-300">
                                                <Icon name="plus" size="20" />
                                            </div>
                                        </Tippy>
                                    ) ||
                                        <button
                                            onClick={handleFileButtonClick}
                                            className={`flex items-center justify-center bg-brand-gray px-2 h-8 w-8 rounded-full transition-all duration-300 disabled:opacity-50 ${attachments.length > 5 ? "disabled" : ""}`}
                                        >
                                            <Icon name="plus" size="20" />
                                        </button>
                                    }
                                </div>

                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    accept="image/*,video/*,audio/*,.pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.txt"
                                    onChange={handleImageChange}
                                    className="hidden"
                                />
                            </div>

                            <Textarea textareaRef={textareaRef} channel={channel} sendMessage={sendMessage} isTagging={isTagging} setSend={setSend} setAttachments={setAttachments} attachments={attachments} tagging={tagging} selectingEmote={selectingEmote} isSelectingEmoji={isSelectingEmoji} />
                            <div className="flex gap-2 items-center bg-brand-top h-full justify-end">

                                <EmojiDropdown emojis={emojis} func={tagEmoji}>
                                    <div
                                        className={`flex items-center mt-2 justify-center px-2 h-9 w-9 rounded-full transition-all duration-300 hover:text-white text-gray-300 cursor-pointer`}
                                    >
                                        <Icon name="emoji" size="48" />
                                    </div>
                                </EmojiDropdown>

                                <button
                                    disabled={!canBeSend}
                                    className={`flex items-center mt-2 justify-center px-2 h-8 w-8 rounded-full transition-all duration-300 ${canBeSend ? 'bg-brand-green' : 'bg-brand-dark cursor-not-allowed'}`}
                                    onClick={sendMessage}
                                >
                                    <Icon name="send" size="36" color="white" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
